<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">权益信息</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="ruleForm" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="权益名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入权益名称" />
          </el-form-item>
          <el-form-item label="权益折扣" prop="discount">
            <div class="d-flex">
              <el-input v-model="form.discount" style="width: calc(100% - 30px);" placeholder="请输入权益折扣" :disabled="$route.query.type==='revise'" />
              <div class="ml-20">%</div>
            </div>
          </el-form-item>
          <el-form-item label="抵扣类型" prop="type">
            <el-radio-group v-model="form.type" :disabled="$route.query.type==='revise'">
              <el-radio :label="2">电费</el-radio>
              <el-radio :label="1">服务费</el-radio>
              <el-radio :label="3">总费用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">使用限制</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="configForm" :model="configForm" :rules="configRules" label-width="100px">
          <el-form-item label="权益说明" prop="remarks">
            <el-input v-model="configForm.remarks" type="textarea" :rows="4" placeholder="请输入权益说明" />
          </el-form-item>
          <el-form-item label="可用电站" prop="powerStation">
            <el-radio-group v-model="configForm.powerStation" @change="configCancelTree()">
              <el-radio v-for="(item, index) in activityPowerStation" :key="index" :label="item.id">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="configForm.powerStation=='1'" prop="operator" label="">
            <!-- 选择运营商 -->
            <div class="border">
              <el-input v-model="filterOperatorText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeOperator"
                :data="operatorTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="configForm.operator"
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                @check-change="handleOperatorChange"
              />
            </div>
          </el-form-item>
          <el-form-item v-if="configForm.powerStation=='2'" prop="station" label="">
            <!-- 选择电站 -->
            <div class="border">
              <el-input v-model="filterStationText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeStation"
                :data="stationTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="configForm.station"
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                @check-change="handleStationChange"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        id: '',
        name: '',
        discount: '',
        type: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入权益名称', trigger: 'blur' }
        ],
        discount: [
          { required: true, message: '请输入权益折扣', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (/^(?:[1-9]\d*)$/.test(value) === true || Number(value) === 0) {
              callback()
            } else {
              callback(new Error('请输入正整数'))
            }
          },
          trigger: 'blur'
          }
        ],
        type: [
          { required: true, message: '请选择抵扣类型', trigger: 'change' }
        ]
      },
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
	  filterOperatorText: '', // 运营商过滤
	  filterStationText: '', // 电站过滤
      // 可用电站
      activityPowerStation: [
        {
          label: '全部电站',
          id: -1
        }, {
          label: '选择运营商',
          id: 1
        }, {
          label: '选择电站',
          id: 2
        }
      ],
      operatorTreeData: [], // 运营商树的全部数据
      stationTreeData: [], // 电站树的全部数据
      configForm: {
        remarks: '',
        powerStation: '', // 可用电站单选框
        operator: [], // 选择运营商时的树数据
        station: []// 选择电站时的树数据
      },
      configRules: {
        remarks: [
          { required: true, message: '请输入权益说明', trigger: 'blur' }
        ],
        powerStation: [
          { required: true, message: '请选择可用电站', trigger: 'change' }
        ],
        operator: [
          { required: true, message: '请选择运营商', trigger: 'change' }
        ],
        station: [
          { required: true, message: '请选择电站', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    filterOperatorText(val) {
      this.$refs.treeOperator.filter(val)
    },
    filterStationText(val) {
      this.$refs.treeStation.filter(val)
    }
  },
  mounted() {
    // 查询全部运营商方法
    this.getOperatorTree()
    // 查询全部电站方法
    this.getStationTree()
    if (this.$route.query.id) {
      this.getDataDetail(this.$route.query.id)
    }
  },
  methods: {
    // 获取权益详细信息
    getDataDetail(id) {
      const data = {
        privilegeId: id
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/privilege/getPrivilegeById',
        data: data,
        method: 'get',
        callback: resp => {
          this.form.id = resp.id
          this.form.name = resp.name
          this.form.type = resp.type
          this.form.discount = resp.discount
          this.configForm.remarks = resp.info
          this.configForm.powerStation = resp.useType
          if (resp.useType == '1') {
            this.configForm.operator = resp.useData.split(',')
          } else if (resp.useType == '2') {
            this.configForm.station = resp.useData.split(',')
          }
        }
      })
    },
    // 查询全部运营商树的数据
    getOperatorTree() {
      const data = {
        treeDepth: 'ORG'
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: data,
        callback: resp => {
          this.operatorTreeData = resp
        }
      })
    },
    // 查询全部电站树的数据
    getStationTree() {
      const data = {
        treeDepth: 'STATION'
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: data,
        callback: resp => {
          this.stationTreeData = resp
        }
      })
    },
    // 树的节点筛选
    filterNode(value, data, node) {
      if (!value) return true
      let parentNode = node.parent
      let labels = [node.label]
      let level = 1
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }
      return labels.some(label => label.indexOf(value) !== -1)
    },
    // 切换可用电站时 取消可用电站的树的选择
    configCancelTree() {
      this.$refs.treeOperator.setCheckedKeys([])
      this.$refs.treeStation.setCheckedKeys([])
    },
    // 选择运营商 赋值
    handleOperatorChange(data, checked, indeterminate) {
      this.configForm.operator = this.$refs.treeOperator.getCheckedKeys()
    },
    // 选择电站 赋值
    handleStationChange(data, checked, indeterminate) {
      this.configForm.station = this.$refs.treeStation.getCheckedKeys()
    },
    onSubmit() {
      let ruleFormBool = false
      this.$refs['ruleForm'].validate(valid => {
        ruleFormBool = valid
      })
      let configFormBool = false
      this.$refs['configForm'].validate(valid => {
        configFormBool = valid
      })

      // 可用电站下面的树的数据
      let stationValue = ''
      if (this.configForm.powerStation == '1') {
        stationValue = this.configForm.operator.join(',')
      } else if (this.configForm.powerStation == '2') {
        stationValue = this.configForm.station.join(',')
      }

      // 表单校验通过
      if (ruleFormBool && configFormBool) {
        const data = this.form

        // this.$route.query.type
        // this.$route.query.id
        if (this.$route.query.type == 'add') {
          data.id = ''
        }
        data.info = this.configForm.remarks
        data.useType = this.configForm.powerStation
        if (data.useType == '-1') {
          // 全部
          data.useData = ''
        } else {
          data.useData = stationValue
        }

        this.$store.dispatch('form/handle', {
          url: '/privilege/saveOrUpdate',
          data: data,
          method: 'post',
          callback: resp => {
            this.$router.go(-1)
          }
        })
      }
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
    .d-flex{
      display: flex;
      justify-content: space-between;
    }
    .flexJCenter{
        display: flex;
        justify-content: center;
    }
    .mt-25{
        margin-top: 25px;
    }
</style>



// WEBPACK FOOTER //
// src/views/equityManagement/editUserEquity.vue